import React, { useState, useEffect } from "react";
import "./Register.css";


const API_BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

const Register = ({ onSwitchToLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [organization_name, setOrganizationName] = useState("");
  const [tier, setTier] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const selectedTier = params.get("tier");
    if (selectedTier) {
      setTier(selectedTier); // store it in state
    }
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();

    if (!email || !password || !organization_name) {
      setError("All fields are required.");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, organization_name, tier }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.detail || "Something went wrong.");
        return;
      }

      setError("");
      setSuccess("✅ Registration successful! Please check your email to verify your account.");
    } catch (err) {
      console.error("Registration error:", err);
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="auth-container">
      <h2>Register</h2>
      {error && <p className="auth-error">{error}</p>}
      {success && <p className="auth-success">{success}</p>}

      <form onSubmit={handleRegister}>
        <input
          type="text"
          placeholder="Organization Name"
          className="auth-input"
          value={organization_name}
          onChange={(e) => setOrganizationName(e.target.value)}
        />
        <input
          type="email"
          placeholder="Email"
          className="auth-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          className="auth-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit" className="auth-button">
          Register
        </button>
      </form>

      <p>
        Already have an account?{" "}
        <span className="auth-switch" onClick={onSwitchToLogin}>
          Login here
        </span>
      </p>
    </div>
  );
};

export default Register;


